import { ItemAttrListDataSet, TableDataColumn } from '@mri/types';

function _getValue(prop: ItemAttrListDataSet, column: TableDataColumn): string | number | boolean {
  if(typeof column.getValue === 'function') return column.getValue(prop);
  return prop.element[column.key];
}

export function tableGetCellRender(prop: ItemAttrListDataSet, column: TableDataColumn) {
  const value = _getValue(prop, column);

  if(typeof value === 'number') return value.toFixed(2);

  return value;
}